import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import SaasSection from '../saas/Section';
import SaasContainer from '../saas/Container';

const FAQ_KEYS = [
  { q: 'landing.faq1q', a: 'landing.faq1a' },
  { q: 'landing.faq2q', a: 'landing.faq2a' },
  { q: 'landing.faq3q', a: 'landing.faq3a' },
  { q: 'landing.faq4q', a: 'landing.faq4a' },
];

const LandingFaqSection = () => {
  const { t } = useTranslation();
  return (
    <SaasSection variant="canvas" className="landing-section-loose !py-14 md:!py-20">
      <SaasContainer>
        <p className="type-eyebrow mb-3 text-center text-steel">{t('landing.faqEyebrow', { defaultValue: 'سوالات متداول' })}</p>
        <h2 className="type-section-title mb-10 text-balance text-center text-2xl md:mb-12 md:text-heading-lg">
          {t('landing.faqTitle')}
        </h2>
        <div className="mx-auto max-w-2xl space-y-3">
          {FAQ_KEYS.map(({ q, a }) => (
            <details
              key={q}
              className="group rounded-2xl border border-hairline/40 bg-card-surface/90 px-5 shadow-saas transition hover:border-signal/20 hover:shadow-[0_12px_32px_-20px_rgba(113,75,103,0.35)] open:border-signal/25 open:shadow-saas-md sm:px-6"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-4 text-start font-medium text-ink-graphite marker:content-none [&::-webkit-details-marker]:hidden">
                <span className="flex-1 leading-snug">{t(q)}</span>
                <ChevronDown
                  className="h-5 w-5 shrink-0 text-signal transition duration-300 group-open:rotate-180"
                  aria-hidden
                />
              </summary>
              <p className="pb-4 pt-0 text-[0.9375rem] leading-[1.75] text-steel group-open:pt-1">{t(a)}</p>
            </details>
          ))}
        </div>
      </SaasContainer>
    </SaasSection>
  );
};

export default LandingFaqSection;
